if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      if (this.cartNotification) this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      const spinner = this.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cartNotification && this.cartNotification.getSectionsToRender) {
        formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          const wbQuick = this.querySelector('.wbquicksuccess');
          if (response.status) {
            if (wbQuick) wbQuick.classList.add('hidden');
            this.handleErrorMessage(response.description);
            return;
          }

          if (this.cartNotification && this.cartNotification.renderContents) {
            this.cartNotification.renderContents(response);
          } else if (typeof jQuery !== 'undefined') {
            jQuery.get('/cart', function(data) {
              var $newCartDrawer = jQuery(data).find('.cartDrawer');
              if ($newCartDrawer.length) {
                var newContent = $newCartDrawer.children().not('.mini-cart-header');
                jQuery('.cartDrawer').children().not('.mini-cart-header').replaceWith(newContent);
              } else {
                var miniCartBodyHTML = jQuery(data).find('.mini-cart-has-item').html();
                jQuery('.mini-cart-has-item').html(miniCartBodyHTML);
              }
              jQuery('.cartDrawer').removeClass('is-empty');
              jQuery.getJSON('/cart.js', function(cart) {
                jQuery('.cart-header .cart-price').text(Shopify.formatMoney(cart.original_total_price));
                jQuery('.cart-header .count').text(cart.item_count);
                if (jQuery('.mini-cart-header .cart-tottl-itm').length) jQuery('.mini-cart-header .cart-tottl-itm').text(cart.item_count + ' Items');
              });
              jQuery('body').addClass('no-scroll cartOpen');
              jQuery('html').addClass('cart-open');
              jQuery('.overlay').addClass('cart_overlay');
            });
          }
          if (wbQuick) wbQuick.classList.remove('hidden');
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          const s = this.querySelector('.loading-overlay__spinner');
          if (s) s.classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
